<template>
  <section class="admin-content" id="contact-search">
    <Navbar />

    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white flex-wrap"
            style="padding: 32px 0; gap: 16px;" v-if="paymentorder.data">
            <div class="d-flex align-items-center" style="gap: 16px;">
              <div class="header-icon-wrap">
                <i class="mdi mdi-receipt" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Payment Order #{{ paymentorder.data.payment_number }}</h4>
                <small style="opacity: .8;">
                  Invoice Date: {{ paymentorder.data.created_at | moment("D/M/YYYY") }}
                </small>
              </div>
            </div>

            <div class="text-right">
              <p class="mb-1" style="opacity:.8; font-size:.78rem; text-transform:uppercase; letter-spacing:.05em;">
                Total Amount
              </p>
              <h3 class="mb-0 font-weight-bold">
                <i class="mdi mdi-currency-ngn"></i>{{ paymentorder.total_claims_cost | numeral(0, 0) }}
              </h3>
            </div>
          </div>

          <div class="d-flex flex-wrap pb-4" style="gap: 8px;" v-if="paymentorder.data">
            <button class="btn btn-outline-light btn-sm" @click="printMe">
              <i class="mdi mdi-printer mr-1"></i> Print
            </button>
            <button @click="payOnline" class="btn btn-light btn-sm font-weight-bold" :disabled="payingOnline"
              v-if="paymentorder.data.type == 'claims' && paymentorder.data.status != 'paid' && user && (user.type == 'shis' || user.type == 'employee')"
              title="Prepare an online payment to the facility's payout account; an approver then approves it">
              <i class="fe fe-send mr-1"></i> Pay online
            </button>
            <button @click="approvePayment" class="btn btn-outline-light btn-sm" v-if="paymentorder.data.status != 'paid'" title="Record that it was paid outside the system">
              <i class="fe fe-check mr-1"></i> Mark as paid (offline)
            </button>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5" v-if="paymentorder.data">
        <div id="printDiv" ref="printNow">
          <div class="card table-card shadow mb-4">
            <div class="card-body p-4">
              <div class="row mb-4">
                <div class="col-md-6">
                  <p class="info-label mb-1">To</p>
                  <p class="h5 font-weight-bold mb-2">{{ paymentorder.data.provider.agency_name }}</p>
                  <span class="badge badge-soft-warning" v-if="paymentorder.data.status == 'pending'">
                    unpaid
                  </span>
                  <span class="badge badge-soft-success" v-if="paymentorder.data.status == 'paid'">
                    <i class="fe fe-check-square mr-1"></i>paid
                  </span>
                </div>
                <div class="col-md-6 text-md-right">
                  <h4 class="font-weight-bold mb-2">Transaction</h4>
                  <p class="mb-1 text-muted" style="font-size:.85rem;">
                    Payment Number: <strong class="text-dark">#{{ paymentorder.data.payment_number }}</strong>
                  </p>
                  <p class="mb-1 text-muted" style="font-size:.85rem;">
                    Payment For: <strong class="text-dark">{{ paymentorder.data.type }}</strong>
                  </p>
                  <p class="mb-0 text-muted" style="font-size:.85rem;">
                    Date: <strong class="text-dark">{{ paymentorder.data.created_at | moment("D/M/YYYY") }}</strong>
                  </p>
                </div>
              </div>

              <div class="row mb-4" v-if="paymentorder.data.claims && paymentorder.data.claims.length">
                <div class="col-md-6 mb-3 mb-md-0">
                  <div class="category-total-box category-total-box--bhcpf">
                    <p class="category-total-label">Basic Healthcare Provision Fund</p>
                    <h5 class="category-total-value">
                      <i class="mdi mdi-currency-ngn"></i>{{ categoryBreakdown.bhcpf | numeral(0, 0) }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="category-total-box category-total-box--others">
                    <p class="category-total-label">Others</p>
                    <h5 class="category-total-value">
                      <i class="mdi mdi-currency-ngn"></i>{{ categoryBreakdown.others | numeral(0, 0) }}
                    </h5>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table align-td-middle mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th">Payment Breakdown</th>
                      <th class="table-th text-right">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="claim in paymentorder.data.claims" v-bind:key="claim.id">
                      <td class="py-2">
                        <p class="mb-0 font-weight-bold" style="font-size:.88rem;">Claim ID: #{{ claim.id }}</p>
                        <p class="mb-0 text-muted" style="font-size:.8rem;">
                          {{ claim.enrollee.firstname }} {{ claim.enrollee.lastname }},
                          {{ claim.seen_date | moment("D/M/YYYY") }},
                          {{ claim.authorization_code }}
                        </p>
                      </td>
                      <td class="py-2 text-right">
                        <i class="mdi mdi-currency-ngn"></i>{{ claim.approved_total_cost | numeral(0, 0) }}
                      </td>
                    </tr>

                    <tr class="table-row" v-for="cap in paymentorder.data.capitations" v-bind:key="cap.id">
                      <td class="py-2">
                        <p class="mb-0 font-weight-bold" style="font-size:.88rem;">Item ID: #{{ cap.id }}</p>
                        <p class="mb-0 text-muted" style="font-size:.8rem;">{{ cap.name }}</p>
                      </td>
                      <td class="py-2 text-right">
                        {{ cap.quantity }} x {{ cap.unit_fee }} =
                        <i class="mdi mdi-currency-ngn"></i>{{ cap.total_amount | numeral(0, 0) }}
                      </td>
                    </tr>

                    <tr style="background:#f0f4ff;">
                      <td class="py-3 font-weight-bold">Total</td>
                      <td class="py-3 text-right font-weight-bold text-primary" style="font-size:1.05rem;">
                        <i class="mdi mdi-currency-ngn"></i>{{ paymentorder.total_claims_cost | numeral(0, 0) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="pt-4 mt-2 border-top text-center">
                <p class="text-muted mb-1" style="font-size:.82rem;">
                  Powered by State Health Insurance Agency
                </p>
                <p class="text-muted mb-0" style="font-size:.78rem; opacity:.75;">&copy; 2025</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// import LetterForPayment from "@/views/funds/LetterForPayment.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      payingOnline: false,
      paymentorder: "",
      agencies: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {
    categoryBreakdown() {
      const claims = (this.paymentorder.data && this.paymentorder.data.claims) || [];
      let bhcpf = 0;
      let others = 0;
      claims.forEach((claim) => {
        const amount = claim.approved_total_cost || 0;
        const sector = claim.enrollee && claim.enrollee.sector;
        if (sector === "Basic Healthcare Provision Fund") {
          bhcpf += amount;
        } else {
          others += amount;
        }
      });
      return { bhcpf, others };
    },
  },
  methods: {
    printMe() {
      var printContents = document.getElementById("printDiv").innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },
    clearIt() {
      this.agency_id = "";
    },
    // online: a claims payment run with this order, approved by someone else on the Online Payments page
    payOnline() {
      if (!confirm("Prepare an online payment of this order to the facility's payout account? An approver must approve it before money is sent.")) return;
      this.payingOnline = true;
      this.axios
        .post("/api/v1/auth/payments/runs/claims", { paymentorder_ids: [this.paymentorder.data.id] })
        .then((res) => {
          this.$toasted.success(res.data.message, { position: "top-center", duration: 5000 });
          this.$router.push(`/online-payments/run/${res.data.data.id}`);
        })
        .catch((e) => {
          const d = e.response && e.response.data;
          this.$toasted.error((d && d.message) || "Could not prepare the online payment.", { position: "top-center", duration: 6000 });
        })
        .finally(() => { this.payingOnline = false; });
    },
    approvePayment() {
      if (confirm("Are you sure")) {
        this.axios
          .post(`/api/v1/auth/update-payment-status/${this.$route.params.id}`, {
            status: "paid",
          })
          .then((response) => {
            console.log(response);
            this.getPayment();
            this.$toasted.info("Updated Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            const d = error.response && error.response.data;
            this.$toasted.error((d && (d.message || d.Message)) || "Could not update the payment.", { position: "top-center", duration: 6000 });
          });
      }
    },
    getPayment() {
      this.axios
        .get(`/api/v1/auth/paymentorder/${this.$route.params.id}`)
        .then((response) => {
          this.paymentorder = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.getPayment();
  },
};
</script>

<style scoped>
.category-total-box {
  border-radius: 10px;
  padding: 14px 18px;
  height: 100%;
}
.category-total-box--bhcpf {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}
.category-total-box--others {
  background: #f0f4ff;
  border: 1px solid #c7d4fb;
}
.category-total-label {
  margin: 0 0 4px;
  font-size: .74rem;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #6b7280;
  font-weight: 700;
}
.category-total-value {
  margin: 0;
  font-weight: 800;
  color: #1e293b;
}
</style>
